import moment from 'moment';
import { BACKEND_DATE_FORMATS, DateFormats } from '#app/helpers/DateFormats';
import type { RoboadvisorStatusData } from '#app/types/roboStatus';

export interface ParsedRoboStatus {
  executionConnected: boolean | null;
  rebalanceConnected: boolean | null;
  canRebalance: boolean | null;
  lastRebalancingTime: string | null;
  rebalancingPassed: boolean | null;
}

export const parseRoboStatus = (
  statusData: RoboadvisorStatusData | null | undefined
): ParsedRoboStatus => {
  if (!statusData) {
    return {
      executionConnected: null,
      rebalanceConnected: null,
      canRebalance: null,
      lastRebalancingTime: null,
      rebalancingPassed: null,
    };
  }

  const executionConnected = statusData.execution_connected;
  const rebalanceConnected = statusData.rebalance_connected;
  const canRebalance = statusData.can_rebalance;
  const rebalancingPassed = statusData.rebalancing_passed ?? statusData.can_rebalance;
  const lastRebalancingTime =
    typeof statusData.last_rebalancing_time === 'string' ? statusData.last_rebalancing_time : null;

  return {
    executionConnected,
    rebalanceConnected,
    canRebalance,
    lastRebalancingTime,
    rebalancingPassed,
  };
};

export const formatStatusValue = (value: boolean | null) => {
  if (value === true) return 'Да';
  if (value === false) return 'Нет';
  return '—';
};

export const formatRebalancingDate = (value: string | null) => {
  if (!value) return '—';
  const parsedDate = moment(value, BACKEND_DATE_FORMATS, true);
  return parsedDate.isValid() ? parsedDate.format(DateFormats.USER_DATETIME) : '—';
};
